<template>
  <div :class="mastheadClass"></div>
</template>

<script>

export default {
  name: 'Masthead',
  computed: {
    mastheadClass() {
      const showAlt = Math.random() > 0.5;
      return `masthead ${showAlt && 'masthead--alt'}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.masthead {
  text-align: center;
  height: 400px;
  max-height: 70vh;
  background: url('/images/mascot.jpg');
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: auto 130%;
  border-bottom: 3px solid var(--color-dark);
  @media all and (max-device-width: 1000px) {
    height: 250px;
  }
  @media all and (max-device-width: 767px) {
    height: 200px;
    background-size: auto 90%;
    padding: 50px 20px;
    background-image: url('/images/mascot_mobile.png');
    background-size: 320px auto;
    &--alt {
      background-image: url('/images/mascot_mobile_2.png');
    }
  }
}
</style>
